/**
 * Created by: Lior Elrom
 * Date: 7/1/15
 * Time: 2:45 PM
 */

'use strict';

var _ = require('underscore');
var PaymentMethod = require('bunsen/models/ecomm/PaymentMethodModel');

var isCardType = function (cardType) {
    return this.getCardType() === cardType;
};

module.exports = {
    isVisa: _.partial(isCardType, PaymentMethod.CARD_TYPE_VISA),
    isMaster: _.partial(isCardType, PaymentMethod.CARD_TYPE_MASTER),
    isDiscover: _.partial(isCardType, PaymentMethod.CARD_TYPE_DISCOVER),
    isAmex: _.partial(isCardType, PaymentMethod.CARD_TYPE_AMEX),

    getDisplayMaskedCard: function () {
        var lastNumbers = this.getLastNumbers();
        var maskedCardStr;
        if (lastNumbers) {
            // Amex: xxxx-xxxxxx-xxxxx
            // Visa/Discover/Master: xxxx-xxxx-xxxx-xxxx
            maskedCardStr = this.isAmex() ? 'xxxx-xxxxxx-x' : 'xxxx-xxxx-xxxx-';
            return maskedCardStr + lastNumbers;
        }
        return;
    },
    isExpired : function () {
        var cardYear = parseInt(this.get('cardExpiryYear'), 10);
        var now = new Date();
        var thisYear = parseInt(now.getFullYear(), 10);
        if (cardYear < thisYear) {
            return true;
        } else if (cardYear > thisYear) {
            return false;
        }
        return (now.getMonth() + 1 > parseInt(this.get('cardExpiryMonth'), 10));
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/mixins/ecomm/creditCardMixin.js
// module id = 84
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54